var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.765,
    height: 37.642,
    viewBox: "0 0 36.765 37.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-555.962 -359.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M574.182,383.452a2.127,2.127,0,1,1-2.127-2.128,2.127,2.127,0,0,1,2.127,2.128Z",
    transform: "translate(-3.432 -5.439)",
    fill: "#3f6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M581.767,383.452a2.128,2.128,0,1,1-2.128-2.128h0a2.127,2.127,0,0,1,2.127,2.127Z",
    transform: "translate(-5.296 -5.439)",
    fill: "#3f6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M589.354,383.452a2.127,2.127,0,1,1-2.127-2.128A2.127,2.127,0,0,1,589.354,383.452Z",
    transform: "translate(-7.161 -5.439)",
    fill: "#3f6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M563.716,385.059a12.752,12.752,0,0,1,17.676-17.677l8.191-8.192-10.53,1.056a18.37,18.37,0,0,0-19.366,28.842Z",
    fill: "#7bc807"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M590.027,369.458,586,373.487a12.752,12.752,0,0,1-17.676,17.676l-8.191,8.191,10.53-1.056a18.371,18.371,0,0,0,19.367-28.843Z",
    transform: "translate(-1.024 -2.523)",
    fill: "#7bc807"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.5d817652.svg";
export { ForwardRef as ReactComponent };